import { l } from '@manychat/manyui'

import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { FlowChartNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNodeHeaderBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import {
  DEFAULT_ICON_RENDER_SIZE,
  GotoConfig,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartGotoNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartGotoNode'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { NodeType } from 'common/builder/constants/NodeType'
import { IGotoNode } from 'common/builder/nodes/nodeInterfaces'
import { getById } from 'common/flow/selectors/flowSelectors'

export const GotoNodeGenericConverterRule: ConverterRule<
  IGotoNode,
  FlowChartGotoNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: IGotoNode) => entity?.nodeType === NodeType.GOTO,
  convert: (entity, { state }) => {
    const entityFlow = getById(state, entity.flowId)

    const nextStep = new FlowChartNextStepBuilder(entity.id)
      .withLabel(l.translate('Next Step'))
      .build()

    const icon = new FlowChartIconBuilder(GotoConfig.iconComponent, DEFAULT_ICON_RENDER_SIZE)
      .withColor(GotoConfig.iconColor || '')
      .build()
    const header = new FlowChartNodeHeaderBuilder(entity.caption)
      .withIcon(icon)
      .withColor(GotoConfig.headerBackground)
      .build()
    const flow = entityFlow
      ? {
          id: entityFlow.id,
          name: entityFlow.name,
          path: entityFlow.path,
        }
      : null

    return {
      id: entity.id,
      nodeType: NodeType.GOTO,
      type: FlowChartNodeType.GOTO,
      onboardingElementId: '',

      data: {
        header,
        flow,
        nextStep: nextStep,
      },
    }
  },
}
